































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Heading from '@components/base/Heading.vue';
import ButtonComponent from '@components/004-ButtonComponent/ButtonComponent.vue';
import ImageComponent from '@components/001-ImageComponent/ImageComponent.vue';
import IconButton from '@components/002-IconButton/IconButton.vue';
import IconTextLink from '@components/005-IconTextLink/IconTextLink.vue';
import Map from '@components/048-Map/Map.vue';
import { IMapLabelWithAttributes } from '@frontend/types/modules/IMaps';
import ILink from '@frontend/types/base/ILink';

@Component({
	hydration: true,
	componentId: 'M016-intro',
	components: {
		Heading,
		ButtonComponent,
		ImageComponent,
		IconButton,
		IconTextLink,
		Map
	}
})
export default class MapsIntro extends Vue {
	@Prop(String)
	protected readonly headline!: string;

	@Prop(Number)
	protected readonly headlineLevel?: number;

	@Prop(String)
	protected readonly copy?: string;

	@Prop(String)
	protected readonly map!: string;

	@Prop(Array)
	protected readonly mapLabels!: IMapLabelWithAttributes[];

	@Prop(Object)
	protected readonly link?: ILink;

	@Prop(String)
	protected readonly linkLabel?: string;
}
